// extracted by mini-css-extract-plugin
module.exports = {"emptyWrapper":"CourseDetailPage_emptyWrapper__DSJP4","emptyText":"CourseDetailPage_emptyText__RDOpY"};